import { render, staticRenderFns } from "./LocationCertificates.vue?vue&type=template&id=19240546&"
import script from "./LocationCertificates.vue?vue&type=script&lang=js&"
export * from "./LocationCertificates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports